var map = {
	"./Icon-Poll.svg": 7606,
	"./Icon-Share-Case.svg": 35132,
	"./Icon-Video.svg": 67846,
	"./Icon-edit-notes.svg": 83371,
	"./Icons_AdjustBrightnessContrast.svg": 14035,
	"./Icons_Adminisration.svg": 3852,
	"./Icons_AnswerAssignment.svg": 28602,
	"./Icons_BlueArrowDown.svg": 83169,
	"./Icons_BlueArrowUp.svg": 66865,
	"./Icons_CaseInformation.svg": 20529,
	"./Icons_ChangeReviewStatus.svg": 81448,
	"./Icons_ClearDrawings_Blue.svg": 71634,
	"./Icons_ClearDrawings_Orange.svg": 8467,
	"./Icons_Comments.svg": 75197,
	"./Icons_Delete.svg": 58502,
	"./Icons_DrawFreehand_Blue.svg": 86368,
	"./Icons_DrawFreehand_Orange.svg": 77041,
	"./Icons_DrawLooped_Blue.svg": 59955,
	"./Icons_DrawLooped_Orange.svg": 40271,
	"./Icons_Edit.svg": 39059,
	"./Icons_EditRecipients.svg": 13410,
	"./Icons_EditorialBoardBox.svg": 92937,
	"./Icons_ExportTSV.svg": 32208,
	"./Icons_ExportTSVALL.svg": 63035,
	"./Icons_Folder.svg": 66051,
	"./Icons_FullPageExit.svg": 42318,
	"./Icons_FullPageView.svg": 51252,
	"./Icons_Hint.svg": 16787,
	"./Icons_ListMode.svg": 2954,
	"./Icons_ListModeSelected.svg": 85173,
	"./Icons_MoveBackForRevision.svg": 33820,
	"./Icons_MoveBackToEditorialBoardBox.svg": 56492,
	"./Icons_MoveToEditorBox.svg": 84475,
	"./Icons_MoveToEditorialBoardBox.svg": 125,
	"./Icons_MoveToPrepublicationBox.svg": 23346,
	"./Icons_MoveToPublicAccessBox.svg": 93305,
	"./Icons_MyEducationalMaterial.svg": 55444,
	"./Icons_MyFolders.svg": 30316,
	"./Icons_NavigationTool.svg": 82317,
	"./Icons_OpenedFolder.svg": 90163,
	"./Icons_PersonalSlideBox.svg": 8829,
	"./Icons_PrePublicationBox.svg": 80718,
	"./Icons_PreviewMode.svg": 24067,
	"./Icons_PreviewModeSelected.svg": 38090,
	"./Icons_ProjectConfiguration.svg": 77154,
	"./Icons_PublicAccessBox.svg": 83693,
	"./Icons_SecondaryArrowDown.svg": 57354,
	"./Icons_SharedByContributors.svg": 75461,
	"./Icons_Sreenshot.svg": 12929,
	"./Icons_Subscriptions.svg": 96686,
	"./Icons_Users.svg": 8365,
	"./Icons_ViewCaseImageAndInfo.svg": 16616,
	"./Icons_ViewResponses.svg": 1235,
	"./Icons_ViewSlidesInfo.svg": 85622,
	"./Icons_hide-annotation.svg": 93754,
	"./Icons_show-annotation.svg": 89260,
	"./icon-add-annotation.svg": 69858,
	"./icon-annotation-list.svg": 67887
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87930;